import React, { useState, useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import Header from "../../../Components/Header/Header";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import ImageUpload from '../../../Components/common/ImageUpload';
import ActivityComments from '../../../Components/common/ActivityComments';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row, Table, Dropdown, Modal, Tab, Tabs, Stack, Button, Form, Accordion } from 'react-bootstrap';
import { faPlus, faXmark, faPencil, faPaperclip, faCalendarDays, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear, faCog, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import Docmnt from '../../../assets/images/google-docs.png';
import Arcv from "../../../assets/images/archive.svg";
import Activ from "../../../assets/images/active.svg";
import edit from "../../../assets/images/edit.png";
import Modal_user from "../../../assets/images/Modal_user.png";
// import view from "../../../assets/images/view.png";
import view from "../../../assets/images/chat.png";
import Select from 'react-select';
import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { GETULDDETAILS, MOVETOACTARC, RECOVERYARCACT, RECOVERYDETAILS, } from '../../../Utils/conts.js';
// import AddRecovery from './AddRecovery';
import { toast } from 'react-toastify';
import MessageBox from '../../../Components/common/MessageBox';
import SettingsIcon from '../../../assets/images/settings.png';
import NewTask from './common/NewTask.js';
import ConfModal from '../../../Components/common/ConfModal.js';
import { jqxCookieCall } from '../../../Components/common/CommonFunctions.js';
import { useUserCheckQuery } from '../../../redux/services/Auth.js';

const TaskManagement = () => {

    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [gridData, setGridData] = useState({
        Active: [],
        Archived: [],
    });
    const [templateData, setTemplateData] = useState();
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);
    const [disLoading, setDisLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('Active');
    const [filterApplied, setFilterApplied] = useState(false);
    const [openTaskModal, setOpenTaskModal] = useState(false);
    const [modalConf, setModalConf] = useState(false);
    const [confData, setConfData] = useState({});

    // const [formData, setFormData] = useState({assign_to:'61'});
    const initialFormData = { assign_to: '61' };
    const [formData, setFormData] = useState(initialFormData);
    const [base64Files, setBase64Files] = useState([]);
    const gridRefs = {
        Active: useRef(null),
        Archived: useRef(null),
    };
    const [departmentList, setDepartmentList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [files, setFiles] = useState([]);
    const userId = localStorage.getItem('UserID');
    const [imageOptions, setImageOptions] = useState([]);
    const [userDetails, setUserDetails] = useState();

      const { data: myData } = useUserCheckQuery('', {
        // skip: pageDetails.pagesize === 0,
      });
      useEffect(() => {
        if (myData?.response_data) {
          setUserDetails(myData?.response_data);
        }
      }, [myData]);

    const taskType = [
        { label: "Custom", value: "Custom" },
        { label: "Finding", value: "Finding" },
        { label: "Finding (minor)", value: "Finding (minor)" },
        { label: "Finding (Major)", value: "Finding (Major)" },
        { label: "Observation", value: "Observation" },
        { label: "Observation (minor)", value: "Observation (minor)" },
        { label: "Observation (Major)", value: "Observation (Major)" },
        { label: "Improvement opportunity", value: "Improvement opportunity" }
    ];
    const notification = [
        { label: "Due = in 3 days, Rem = the day before", value: 1, dueOffset: 3, remOffset: 1 },
        { label: "Due = in a week, Rem = two days before", value: 2, dueOffset: 7, remOffset: 2 },
        { label: "Due = two weeks, Rem = 3 days before", value: 3, dueOffset: 14, remOffset: 3 },
        { label: "Due = one month, Rem = a week before", value: 4, dueOffset: 30, remOffset: 7 },
        { label: "Due = two months, Rem = a week before", value: 5, dueOffset: 60, remOffset: 7 },
        { label: "Due = 3 months, Rem = a week before", value: 6, dueOffset: 90, remOffset: 7 }
    ];

    const options = [
        { value: '1', label: 'One' },
        { value: '2', label: 'Two' },
        { value: '3', label: 'Three' },
    ];

    const fetchdeparrtment = async () => {
        try {
            const res = await withRFSToken.get("/organisation-department/dropdown")
                .then(function (res) {

                    const innerData = res.data.response_data;

                    const transformData = innerData ? innerData.map((item) => ({
                        label: item.label,
                        value: item.value
                    })) : []
                    setDepartmentList(transformData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchuser = async () => {
        try {
            const res = await withRFSToken.post("uld-setting/get-user-list", { status: 'A' })
                .then(function (res) {
                    const innerData = res.data.Rows;
                    const transformData = innerData ? innerData.map((item) => ({
                        label: item.first_name + ' ' + item.last_name,
                        value: item.user_id
                    })) : []
                    setUserList(transformData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchData = async () => {
        try {
            const res = await withRFSToken.get('template/list')
                .then(function (res) {
                    const innerData = res.data.Rows;
                    setTemplateData(innerData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    const fetchImage = async () => {
        try {
            const res = await withRFSToken.get("/file-management/list")
                .then(function (res) {
                    const data = res.data.Rows;

                    const transformData = data?.map(item => ({
                        label: item.file_name,
                        value: item.id,
                        imageUrl: `${item.file_path}`
                    })) || [];

                    setImageOptions(transformData);

                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (isMounted.current) return;
        // Call the fetchData function to fetch data from the API
        // fetchDataGrid();
        setIsLoading(false);
        setGridData({ Active: {} });
        fetchData();
        fetchdeparrtment();
        fetchuser();
        fetchImage();
        // fetchDataGridR();
        isMounted.current = true;
    }, []);

    const handleTabChange = async (tab) => {
        setActiveTab(tab);
        // const tabType = () => {tab == 'Active' ? 'A' : 'R'}
        setFilterApplied(false);
        if (selectedRowData) {
            setSelectedRowData(null)
        }
        setGridSelect([]);
        setIsLoading(true);
        if (tab == 'Active') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Active: {} });
            }, 1);
        } else {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Archived: {} });
            }, 1);
        }
    };

    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRefs[activeTab]?.current) {
            // var token = "Bearer " + localStorage.ASR;
            jqxCookieCall();
            let tabType = '';
            if (activeTab == 'Active') { tabType = 'A' } else { tabType = 'R' }
            const source = {
                datatype: 'json',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'created_on', type: 'string' },
                    { name: 'status', type: 'string' },
                    { name: 'status_label', type: 'string' },
                    { name: 'title', type: 'string' },
                    { name: 'due_date', type: 'string' },
                    { name: 'assign_name', type: 'string' },
                    { name: 'progress', type: 'string' },
                    { name: 'completed_date', type: 'string' },
                    { name: 'organization', type: 'string' },
                    { name: 'updated_on', type: 'string' },
                    { name: 'updated_by', type: 'string' },
                    { name: 'master_airway_bill', type: 'string' },
                    { name: 'template_id', type: 'string' },
                    { name: 'taskable_id', type: 'string' },
                    { name: 'trucking_id', type: 'string' },
                    { name: 'master_airway_bill', type: 'string' },
                    { name: 'document_ref', type: 'string' },
                ],
                id: `${activeTab}-`,
                url: `${process.env.REACT_APP_RFS_URL}task/list?tab=${tabType}`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                pagesize: 50,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


                    // setTimeout(() => {
                    //     const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');

                    //     console.log("rows", rows);
                    //     (checkUlds).forEach(uldNumber => {
                    //         console.log(checkUlds);
                    //         rows.forEach((element, index) => {
                    //             if (element.uld_number == uldNumber) {
                    //                 window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                    //             }
                    //         });
                    //     });
                    // }, 4000);
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;

                    // setMissingCount(data?.missingCount || 0);
                    // setTotalRows({ totalUlds: data.activeCount });
                    // setTotalRowsR({ totalUlds: data.archiveCount });
                },
                sort: function () {
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                {
                    text: 'Actions',
                    cellsrenderer: function () {
                        return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /></div>';
                    },
                    width: '4%', filterable: false,
                },
                {
                    text: 'Status',
                    datafield: 'status_label',
                    width: '8%',
                    filtertype: 'checkedlist',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        // console.log('270', rowdata)
                        // Check the value of the 'Status' field
                        if (rowdata.status_label === 'Assigned' || rowdata.status_label === 'Open') {
                            // Return HTML with class 'inactive' for 'i' status
                            return '<div class="jqx-grid-cell-left-align  task_assigned">' + value + ' </div>';
                        } else if (rowdata.status_label === 'In Progress') {
                            // Return HTML with class 'active' for 'a' status
                            return '<div class="jqx-grid-cell-left-align  task_inprogress">In Progress</div>';
                        } else if (rowdata.status_label === 'On Hold') {
                            // Return HTML with class 'active' for 'a' status
                            return '<div class="jqx-grid-cell-left-align  task_onhold"> On Hold </div>';
                         } else if (rowdata.status_label === 'Completed') {
                            // Return HTML with class 'active' for 'a' status
                            return '<div class="jqx-grid-cell-left-align  task_completed">Completed</div>';
                        } else if (rowdata.status_label === 'Failed') {
                            // Return HTML with class 'active' for 'a' status
                            return '<div class="jqx-grid-cell-left-align  task_failed">Failed</div>';
                         } else {
                            // Return default HTML
                            return defaulthtml;
                        }
                    }
                },
                { text: 'Created On', filtertype: 'range', cellsformat: 'dd-MM-yyyy', filtermode: 'range', datafield: 'created_on', width: '8%', cellclassname: '', },
                { text: 'Task Title', filtertype: 'textbox', datafield: 'title', width: '15%', cellclassname: '', },
                { text: 'Due Date', filtertype: 'range', cellsformat: 'dd-MM-yyyy', filtermode: 'range', datafield: 'due_date', width: '8%', cellclassname: '', },
                { text: 'Assigned', filtertype: 'textbox', datafield: 'assign_name', width: '8%', cellclassname: '', },

                // {
                //     text: 'Progress',
                //     datafield: 'progress',
                //     width: '8%',
                //     filtertype: 'textbox',
                //     cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                //         return `<div style="margin-top: 5px;">${value != null ? value + '%' : ''}</div>`;
                //     }
                // },

                { text: 'Last Updated', filtertype: 'textbox', cellsformat: 'dd-MM-yyyy', datafield: 'updated_on', width: '8%', cellclassname: '', },
                { text: 'Updated By', filtertype: 'textbox', cellsformat: 'dd-MM-yyyy', datafield: 'updated_by', width: '8%', cellclassname: '', },
                { text: 'Organization', filtertype: 'textbox', datafield: 'organization', width: '8%', cellclassname: '', },
                {
                    text: 'Recovery Id', filtertype: 'textbox', datafield: 'master_airway_bill', width: '8%', cellclassname: 'rec_details',
                    cellsrenderer: function (row, columnfield, value) {
                        return '<div class="grid_actions" style="text-decoration:underline; cursor:pointer">'+ value +'</div>';
                    },
                },
                // { text: 'Document Ref', filtertype: 'textbox', datafield: 'document_ref', width: '8%', cellclassname: '', },
            ];
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox',
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
                rendered: function () {
                    const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                    (checkUlds).forEach(uldNumber => {
                        rows.forEach((element, index) => {
                            if (element.uld_number == uldNumber) {
                                window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                            }
                        });
                    });
                }
            };
            window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
            window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRefs[activeTab].current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    // console.log('Global Index:', globalIndex); 
                    const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        console.log('Row Data:', rowData);

                        localStorage.setItem('rowId', JSON.stringify(rowData.id));
                        window.location.href = "/EditTask";
                        // setEditData(dataToSend);
                        // setShowEdit(true);
                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }
                // const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);

            });
            window.$(gridRefs[activeTab].current).on('click', '.rec_details', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                    // console.log('rowData', rowData); 
                    if (rowData?.taskable_id != null) {
                        localStorage.removeItem('RecoveryEdit');
                        console.log('Row Data:', rowData);
                        localStorage.setItem('RecoveryEdit', JSON.stringify({ service_recovery_id: rowData.taskable_id }));
                        const fnPageUrl = '/OverviewDetails';
                        window.location.href = fnPageUrl;
                    } else {
                        toast.error(' No taskable ID found for this row');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }
                // const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);

            });
            window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.id;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    } setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    // }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.id === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.id !== unselectedRowId));
                    // if(filterForCheck!=true){
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                    // }
                    // console.log(checkUlds);

                }
            });
            // window.$(gridRefs[activeTab].current).off('cellclick');
            // window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
            //     const args = event.args.row.bounddata;
            //     if (event.args.columnindex > 1 && event.args.columnindex == 10) {
            //         // console.log("10");
            //         const rowDiv = window.$(this).closest('[role="row"]');
            //         const rowIndex = window.$(rowDiv).attr('row-id');
            //         const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);
            //         const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
            //         const pageIndex = pagingInfo.pagenum;
            //         const pageSize = pagingInfo.pagesize;
            //         const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;

            //         // console.log('Row Index:', rowIndex, 'Bound Index:', boundIndex, 'Global Index:', globalIndex);

            //         const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', boundIndex);
            //         console.log('rowData', rowData);

            //         if (rowData?.taskable_id != null) {
            //             localStorage.removeItem('RecoveryEdit');
            //             console.log('Row Data:', rowData);
            //             localStorage.setItem('RecoveryEdit', JSON.stringify({ service_recovery_id: rowData.taskable_id }));
            //             // const fnPageUrl = '/OverviewDetails';
            //             // window.location.href = fnPageUrl;
            //         } else {
            //             console.warn(' No row data found for index:', boundIndex);
            //         }
            //     }
            //     else if (event.args.columnindex > 1) {
            //         if (gridSelect) {
            //             gridSelect.forEach(item => {
            //                 const selectedRowBoundIndex = item.boundindex;
            //                 window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
            //             });
            //         }
            //         loadDetails(args.uld_number);
            //     }
            // });

        }
    }, [gridData]);


    const loadDetails = async (edt, uldNumber) => {
        try {
            const res = await withRFSToken.post(RECOVERYDETAILS, { service_recovery_id: uldNumber })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log("🚀 ~ .then ~ innerData:654", innerData)
                    if (edt === 'E') {
                        localStorage.removeItem('RecoveryEdit');
                        localStorage.setItem('RecoveryEdit', JSON.stringify(innerData));
                        const fnPageUrl = '/AddRecovery';
                        window.location.href = fnPageUrl;
                    } else if (edt === 'U') {
                        localStorage.removeItem('RecoveryUpdate');
                        localStorage.setItem('RecoveryUpdate', JSON.stringify(innerData));
                        const fnPageUrl = '/UpdateRecovery';
                        window.location.href = fnPageUrl;
                    } else {
                        setSelectedRowData(innerData);
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleCloseClick = () => {
        setSelectedRowData(null);
    };

    // upload forward
    const fileInputRef = useRef(null);
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    const [actArcModal, setActArcModal] = useState(false);
    const handleMoveToActArc = () => {

        if (gridSelect.length == 0) {
            toast.error('Please select grid data before send');
        } else {
            console.log('111111');
            // setActArcModal(true);
            // setModalAction(() => confirmMoveToActArc); // Set the action to be performed on confirmation

            setConfData({
                header: `Data  move to ${activeTab == 'Active' ? 'Archive' : 'Active'}`,
                subHeader: `If you confirm this, data will move to  ${activeTab == 'Active' ? 'Archive' : 'Active'}`,
                modalConf: () => confirmMoveToActArc(),
                closeModal: confModalClose,
                primaryBtn: 'Yes',
                secondaryBtn: 'No',
            })
            setModalConf(true);
        }
    };
    const confModalClose = () => setModalConf(false);
    const confirmMoveToActArc = async () => {
        // console.log('101', gridSelect);
        const sendAction = activeTab == 'Active' ? 'R' : 'A';
        const uldNumbers = gridSelect && gridSelect.map(num => num.id)

        try {
            const res = await withRFSToken.post('task/move-archive', { id: uldNumbers, action: sendAction })
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        // setGridSelect([]);
                        window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                        confModalClose()
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleDefineTask = () => {
        setActArcModal(true)
    }

    const resetFilters = () => {
        window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
        // gridSelect.forEach(item => {
        //     const selectedRowBoundIndex = item.boundindex;
        //     window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
        // });
        // setGridSelect([]);
    };

    const edithandler = (id) => {
        localStorage.setItem('RecoveryEdit', JSON.stringify(id));
        localStorage.setItem('EditFrom', JSON.stringify('SR'));
        const fnPageUrl = '/UpdateHandlerRecovery';
        window.location.href = fnPageUrl;
    }
    const findPrimary = selectedRowData?.attachments?.filter((attachment) => attachment.primary === 1);
    const [selectedFile, setSelectedFile] = useState("");
    const [imgShow, setImgShow] = useState(false);
    const handleFileClick = (file) => {
        setSelectedFile(file);
        setImgShow(true);
    };
    const handleClose = () => {
        setImgShow(false);
        setSelectedFile("");
    };

    const handleFieldChange = (field, value) => {
        if (field === 'notifications') {
            const selectedOption = notification.find((n) => n.value === parseInt(value));
            if (selectedOption) {
                const now = new Date();
                const dueDate = new Date(now.getTime() + selectedOption.dueOffset * 24 * 60 * 60 * 1000);
                const reminderDate = new Date(dueDate.getTime() - selectedOption.remOffset * 24 * 60 * 60 * 1000);

                const formatDateTimeLocal = (date) => {
                    const pad = (n) => (n < 10 ? '0' + n : n);
                    const year = date.getFullYear();
                    const month = pad(date.getMonth() + 1);
                    const day = pad(date.getDate());
                    const hours = pad(date.getHours());
                    const minutes = pad(date.getMinutes());
                    return `${year}-${month}-${day}T${hours}:${minutes}`;
                };

                setFormData((prev) => ({
                    ...prev,
                    notifications: value,
                    due_date: formatDateTimeLocal(dueDate),
                    reminder_date: formatDateTimeLocal(reminderDate)
                }));
            }
        } else {
            if (field == 'assign_to' && value == 60) {
                setFormData((prev) => ({
                    ...prev,
                    [field]: value,
                    assigned_user_id: userDetails?.user_id ? userDetails?.user_id : '',
                }));
            } else {
                setFormData((prev) => ({
                    ...prev,
                    [field]: value
                }));
            }

        }
    };

    const defineTask = async () => {
        console.log("paylaod==>", formData);
        // return false
        setDisLoading(true);
        try {
            const res = await withRFSToken.post("task/add-update", formData);
            if (res.data.response_code == 200) {
                setActArcModal(false)

                window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                toast.success(res.data.response_msg);

            } else {

                toast.error(res.data.response_msg);
            }
            setDisLoading(false);
        } catch (error) {
            console.error('Error sending request:', error);
            setDisLoading(false);
        }
    };

    const [showSettings, setShowSettings] = useState(false);
    const handleSettingsClick = () => {
        setShowSettings(prev => !prev);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);

    };
    const handleDragOver = (e) => {
        e.preventDefault();
    };
    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];
        let filesProcessed = 0;

        // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
        const existingBase64Files = formData?.base64Files || [];
        const existingFiles = formData?.files || [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
                filesProcessed += 1;
                if (filesProcessed === selectedFiles.length) {
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    // const newBase64Files = filesWithBase64.map((obj) => obj.base64);
                    const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
                    const mergedFiles = [...existingFiles, ...newBase64Files];
                    // setFiles(newFiles);
                    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                    setBase64Files(mergedBase64Files);
                    setFormData((prevFormData) => {
                        // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                        const newFormData = { ...prevFormData, files: mergedFiles, base64Files: mergedBase64Files };

                        return newFormData;
                    });
                }
            };
            reader.readAsDataURL(file);
        });
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const [selectedKeys, setSelectedKeys] = useState([]);
    const [editFiles, setEditFiles] = useState([]);
    const [isTopDel, setIsTopDel] = useState(false);

    const handleImageSelect = (key, data) => {
        console.log("🚀 ~ handleImageSelect ~ data:", data)

        if (formData.files) {
            const extension = data?.name?.split('.').pop().toLowerCase();
            if (["jpeg", "jpg", "png", "webp"].includes(extension)) {
                setFormData((prevFormData) => {
                    const updatedFiles = prevFormData.files.map((file, index) => {
                        if (index === key) {
                            // Toggle the "primary" field for the selected file
                            return {
                                ...file,
                                primary: file.primary === 1 ? 0 : 1,
                            };
                        }
                        return file;
                    });

                    return {
                        ...prevFormData,
                        files: updatedFiles,
                    };
                });

                setSelectedKeys((prevSelected) =>
                    prevSelected.includes(key)
                        ? prevSelected.filter((selectedKey) => selectedKey !== key) // Remove key if already selected
                        : [...prevSelected, key] // Add key if not selected
                );
            }
        }
        if (["jpeg", "jpg", "png", "webp"].includes(data?.file_type)) {

            setEditFiles((prevFiles) =>
                prevFiles.map((file) =>
                    file.id === data.id
                        ? { ...file, primary: file.primary === 1 ? 0 : 1 } // Toggle primary between 1 and 0
                        : file // Leave other files unchanged
                )
            );
        }

    };

    const handleDeleteFile = (index, id, type) => {
        if (isTopDel) {
            setEditFiles((prevFiles) => {
                const newFiles = [...prevFiles];
                newFiles.splice(index, 1);
                return newFiles;
            });
        } else {
            setFiles((prevFiles) => {
                const newFiles = [...prevFiles];
                newFiles.splice(index, 1);
                return newFiles;
            });
            // base64Files.splice(index, 1);
            setBase64Files((prevBase64Files) => {
                const newBase64Files = [...prevBase64Files];
                newBase64Files.splice(index, 1);

                // Update local storage
                setFormData((prevFormData) => {
                    const newFormData = { ...prevFormData, base64Files: newBase64Files };
                    return newFormData;
                });

                return newBase64Files;
            });
        }

    };

    const formatOptionLabel = ({ label, imageUrl }, { context }) => {
        const truncateLabel = (label) => {
            if (label.length <= 3) return label;
            return label.slice(0, 3) + '...';
        };

        const displayLabel = context === 'value' ? truncateLabel(label) : label;

        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <img
                    src={imageUrl}
                    alt={label}
                    style={{
                        width: 30,
                        height: 30,
                        objectFit: 'cover',
                        borderRadius: 4,
                        marginRight: 10
                    }}
                />
                <span>{displayLabel}</span>
            </div>
        );
    };
    const openDefineTask = () => {
        setOpenTaskModal(true)
    }
    const reloadGrid = () => {
        setOpenTaskModal(false)
        window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
    }
    const closeNewTask = () => {
        setOpenTaskModal(false)
    }
    return (
        <>
            {openTaskModal && <NewTask onReload={reloadGrid} onClose={closeNewTask} />}
            {modalConf &&
                <ConfModal
                    header={confData.header}
                    subHeader={confData.subHeader}
                    modalConf={confData.modalConf}
                    closeModal={confData.closeModal}
                    primaryBtn={confData.primaryBtn}
                    secondaryBtn={confData.secondaryBtn}
                />
            }
            <div className="mb-3 nestedtabs rounded minh">
                <div className='d-flex'>
                    <button className="addtruck me-2" variant="primary" onClick={openDefineTask}> {/* onClick={handleDefineTask} */}
                        <span> <FontAwesomeIcon icon={faPlus} /> Define Task</span>
                    </button>

                </div>
            </div>
            <div className='ulddown'>
                <button onClick={handleMoveToActArc}>
                    <img title='' src={activeTab == 'Active' ? Arcv : Activ} />
                    {activeTab == 'Active' ? ' Archive' : ' Active'}
                </button>
            </div>
            <div className="maindiv">

                <div className='trashdonload'>
                    {disLoading &&
                        <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
                    }

                    <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                        <Tab eventKey="Active" title={<span> Active </span>} className='moveto'>
                            {/* <Loader isLoading={isLoading} /> */}
                            {!isLoading && <>
                                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                                <div ref={gridRefs.Active} className='bookinggrid' ></div>
                            </>
                            }
                            {/* <div ref={gridRefs.Active} className='bookinggrid' ></div> */}
                        </Tab>
                        <Tab eventKey="Archived" title={<span>Close </span>} className='moveto'>
                            {/* <Loader isLoading={isLoading} /> */}
                            {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                            {!isLoading && <div ref={gridRefs.Archived} className='bookinggrid' ></div>}
                            {/* <div ref={gridRefs.Archived} className='bookinggrid' ></div> */}
                        </Tab>
                    </Tabs>
                </div>
                {selectedRowData && (
                    <div className='SecondDiv mt-45'>
                        {/* {console.log('55', selectedRowData)} */}
                        <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
                        <div className='girddtals_header'>
                            <h3 className='reco_status'>
                                {selectedRowData.master_airway_bill_prefix} - {selectedRowData.master_airway_bill_no} &nbsp;
                                <label
                                    className={selectedRowData?.recovery_status == 'Open' ? 'open'
                                        : (selectedRowData?.recovery_status == 'Traced' ? 'traced'
                                            : (selectedRowData?.recovery_status == 'Progress' ? 'reco_progress'
                                                : (selectedRowData?.recovery_status == 'Closed' ? 'closes' : '')
                                            )
                                        )
                                    }

                                >
                                    {selectedRowData?.recovery_status == 'Closed' ? selectedRowData?.recovery_status : selectedRowData?.status}
                                </label>
                            </h3>
                            <div className='d-flex actbtn justify-content-between'>
                                <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>

                                <div className='viwall' onClick={() => loadDetails('E', selectedRowData.service_recovery_id)}><Link to='#'>Details</Link></div>
                            </div>
                        </div>
                        <div className='mt-3'>
                            <div className='mb-3'>
                                <h3>Highlighted Image(s)</h3>
                                {selectedRowData?.attachments && (
                                    <div className='main_primary'>
                                        {findPrimary.map((file, index) => {
                                            const fileName = file?.file_name;
                                            // console.log("🚀 ~ {files.map ~ file:", file)
                                            const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                            const extension = fileName?.split(".").pop();
                                            return (
                                                <>
                                                    <div key={`ns_${index}`} className='primary_image'>
                                                        {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                                        ) ? (
                                                            <div>
                                                                <img
                                                                    src={file.file_path}
                                                                    alt="Preview"
                                                                    style={{
                                                                        maxWidth: "100%",
                                                                        maxHeight: "100%",

                                                                    }}
                                                                    // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                    onClick={() =>
                                                                        handleFileClick(file.file_path)
                                                                    }
                                                                />
                                                            </div>
                                                        ) : (
                                                            <>
                                                                <span className="">
                                                                    <img src={Docmnt} className="fileimg" />
                                                                </span>
                                                            </>
                                                        )}
                                                        <span className="rafilename">
                                                            {baseName?.length <= 5 ? fileName : `${baseName?.substring(0, 5)}... .${extension}`}
                                                        </span>

                                                    </div>
                                                </>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                            <h3>Station Handler Information</h3>
                            {selectedRowData?.stations?.map((station, index) => (
                                <>
                                    <div className='recover_box mb-3'>
                                        <div className='d-flex justify-content-between align-items-center'>

                                            <div>
                                                <h3>{station.station_name}</h3>
                                                <span>{station.handler_name}</span>
                                            </div>

                                            <div className='text-end'>
                                                <Link to="#" onClick={() => edithandler(station.handler_feedback_id)}> <FontAwesomeIcon icon={faPencil} /> Edit</Link>
                                                {station.updated_by ?
                                                    <span className='d-block last_update'>Updated : {station.updated_by} </span>
                                                    :
                                                    <span className='d-block'>Not Updated</span>
                                                }
                                            </div>
                                        </div>

                                        <ul className='d-flex justify-content-between px-0'>
                                            <li>
                                                <span>Pieces Traced :</span>
                                                <span>{station.pieces_traced || ''}</span>
                                            </li>
                                            <li>
                                                <span>Tracing Date :</span>
                                                <span>{station.tracing_date || ''}</span>
                                            </li>
                                        </ul>

                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>Handler Action</Accordion.Header>
                                                <Accordion.Body>
                                                    {station?.handler_action?.map((actn, index) => (
                                                        <>
                                                            {actn.warehouse_check == true &&
                                                                <div className='d-flex border_bt' key={index}>
                                                                    <div>
                                                                        <Form.Check
                                                                            inline
                                                                            type="checkbox"
                                                                            id="autoSizingCheck"
                                                                            className="me-0 mb-0"
                                                                            label={`Warehouse Check ${index + 1}`}
                                                                            checked={actn.warehouse_check}
                                                                            disabled
                                                                        />
                                                                        <Form.Label className='list_date'><FontAwesomeIcon icon={faCalendarDays} /> {actn?.warehouse_check_date || ''}</Form.Label>
                                                                    </div>
                                                                    <div>
                                                                        <Form.Check
                                                                            inline
                                                                            type="checkbox"
                                                                            id="autoSizingCheck"
                                                                            className="me-0 mb-0"
                                                                            label={`Contacted Agent ${index + 1}`}
                                                                            checked={actn.contacted_agent}
                                                                            disabled
                                                                        />
                                                                        <Form.Label className='list_date'><FontAwesomeIcon icon={faCalendarDays} /> {actn?.contacted_agent_date || ''}</Form.Label>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </>
                                                    ))}
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </>
                            ))}


                        </div>
                        <div>

                        </div>

                        <ImageUpload
                            ref={imageUploadRef}
                            attachable_type={"service_recovery"}
                            attachable_id={selectedRowData.service_recovery_id}
                            attachments={selectedRowData.attachments}
                            onDeleteSuccess={() => loadDetails('', selectedRowData.service_recovery_id)}
                            attachment_no={`${selectedRowData.master_airway_bill_prefix} - ${selectedRowData.master_airway_bill_no}`}
                        />
                        <ActivityComments
                            commentable_type={"service_recovery"}
                            commentable_id={selectedRowData.service_recovery_id}
                            allactivities={selectedRowData.activities}
                            onReloadDetails={() => loadDetails('', selectedRowData.service_recovery_id)}
                        />
                    </div>
                )}
            </div>

            <Modal show={actArcModal} onHide={() => {
                setActArcModal(false);
                setFormData(initialFormData);
            }} className='add_task_modal' centered size="xl">
                <Modal.Header closeButton >
                    <h6><img src={Modal_user} alt='' className='me-2' />Define and assign a new task</h6>
                </Modal.Header>
                <Modal.Body>
                    <Form className='add_taskForm'>
                        <Row>
                            <Form.Group as={Col} md="6" controlId="validationCustom01">
                                <Form.Label>Use template</Form.Label>
                                <Form.Select
                                    required
                                    value={formData.template_id}
                                    onChange={(e) => {
                                        const selectedId = parseInt(e.target.value);
                                        const selectedTemplate = templateData.find(item => item.id === selectedId);
                                        handleFieldChange('template_id', selectedId);
                                        if (selectedTemplate) {
                                            handleFieldChange('title', selectedTemplate.template_title);
                                            handleFieldChange('content', selectedTemplate.content || '');
                                        } else {
                                            handleFieldChange('title', '');
                                            handleFieldChange('content', '');
                                        }
                                    }}
                                >
                                    <option value="">Select a template</option>
                                    {templateData?.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.template_title} - {item.template_name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                            <Form.Group as={Col} md="6" controlId="validationCustom02">
                                <Form.Label>Title</Form.Label>
                                <Form.Control
                                    required
                                    type="text"
                                    placeholder="Title"
                                    value={formData.title}
                                    onChange={(e) => handleFieldChange('title', e.target.value)}
                                />
                            </Form.Group>
                        </Row>
                        <Row className='mt-3'>
                            <h6>Assignment and notifications</h6>
                            <Col md={6}>

                                <Form.Group as={Row} className="mb-3" controlId="formPlaintextAssign to">
                                    <Form.Label column sm="3">Assign to</Form.Label>
                                    <Col sm="9">
                                        <Form.Group>
                                            {['radio'].map((type) => (
                                                <div key={`inline-${type}`} className="">
                                                    <Form.Check
                                                        inline
                                                        label="Myself"
                                                        name="group1"
                                                        type={type}
                                                        id={`inline-${type}-1`}
                                                        value="60"
                                                        checked={formData.assign_to === '60'}
                                                        onChange={(e) => handleFieldChange('assign_to', e.target.value)}
                                                    />
                                                    <Form.Check
                                                        inline
                                                        label="A person"
                                                        name="group1"
                                                        type={type}
                                                        id={`inline-${type}-2`}
                                                        value="61"
                                                        checked={formData.assign_to === '61'}
                                                        onChange={(e) => handleFieldChange('assign_to', e.target.value)}
                                                    />
                                                    <Form.Check
                                                        inline
                                                        label="Department"
                                                        type={type}
                                                        id={`inline-${type}-3`}
                                                        value="62"
                                                        checked={formData.assign_to === '62'}
                                                        onChange={(e) => handleFieldChange('assign_to', e.target.value)}
                                                    />
                                                </div>
                                            ))}
                                        </Form.Group>
                                    </Col>
                                </Form.Group>
                                {(formData.assign_to === '61' || formData.assign_to === '62') && (
                                    <Form.Group as={Row} className="mb-3" controlId="formPlaintextDepartment">
                                        <Form.Label column sm="3">Department</Form.Label>
                                        <Col sm="9">
                                            <Select
                                                options={departmentList}
                                                value={departmentList.find(option => option.value == formData.department_id) || null}
                                                onChange={selected => handleFieldChange('department_id', selected ? selected.value : '')}
                                                placeholder="Select department"
                                                isClearable
                                            />
                                        </Col>
                                    </Form.Group>
                                )}
                                {formData.assign_to === '60' &&
                                    <Form.Group as={Row} className="mb-3" controlId="formPlaintextAssignedUser">
                                        <Form.Label column sm="3">Assigned user</Form.Label>
                                        <Col sm="9">
                                            <Select
                                                options={userList}
                                                onChange={selected => setFormData({ ...formData, assigned_user_id: selected ? selected.value : '' })}
                                                placeholder="Select user"
                                                // disabled={formData.assign_to === '60'}
                                                className=''
                                                name="assigned_user_id"
                                                value={userList.find(option => option.value == formData.assigned_user_id) || null}
                                                isClearable
                                                isDisabled={formData.assign_to == 60 && formData.assigned_user_id == userDetails?.user_id}
                                            />
                                        </Col>
                                    </Form.Group>
                                }
                                {formData.assign_to === '61' && (
                                    <Form.Group as={Row} className="mb-3" controlId="formPlaintextAssignedUser">
                                        <Form.Label column sm="3">Assigned user</Form.Label>
                                        <Col sm="9">

                                            <Select
                                                options={userList}
                                                onChange={selected => setFormData({ ...formData, assigned_user_id: selected ? selected.value : '' })}
                                                placeholder="Select user"
                                                disabled={formData.assign_to === '60'}
                                                className=''
                                                name="assigned_user_id"
                                                value={userList.find(option => option.value === formData.assigned_user_id) || null}
                                                isClearable
                                            />
                                        </Col>
                                    </Form.Group>
                                )}

                                <Form.Group as={Row} className="mb-3" controlId="formPlaintextNotifications">
                                    <Form.Label column sm="3">
                                        Notifications
                                    </Form.Label>
                                    <Col sm="9">
                                        <Form.Select
                                            aria-label="Default select example"
                                            value={formData.notifications}
                                            onChange={(e) => handleFieldChange('notifications', e.target.value)}
                                        >
                                            <option value="">(Quick setup the Due & Reminder dates)</option>
                                            {notification.map((opt) => (
                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="formPlaintextOverduenotif.">
                                    <Form.Label column sm="3">Due date</Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            type="datetime-local"
                                            placeholder="Select Date"
                                            value={formData.due_date}
                                            onChange={(e) => handleFieldChange('due_date', e.target.value)}
                                        />
                                    </Col>
                                </Form.Group>


                            </Col>
                            <Col md={6}>

                                <div className="d-flex justify-content-end">
                                    <div className='task-settings' onClick={handleSettingsClick} style={{ cursor: 'pointer' }}>
                                        <FontAwesomeIcon icon={showSettings ? faTimes : faCog} size="lg" />
                                    </div>
                                </div>
                                {showSettings && (
                                    <div>
                                        <Form.Group as={Row} className="mb-3" controlId="formPlaintextOverduenotif.">
                                            <Form.Label column sm="3">Overdue notif.</Form.Label>
                                            <Col sm="9">
                                                <Form.Control
                                                    type="datetime-local"
                                                    placeholder="Overdue notif"
                                                    value={formData.overdue_notif}
                                                    onChange={(e) => handleFieldChange('overdue_notif', e.target.value)}
                                                />
                                            </Col>
                                        </Form.Group>

                                        <Form.Group as={Row} className="mb-3" controlId="formPlaintextOverduenotif.">
                                            <Form.Label column sm="3">Reminder date</Form.Label>
                                            <Col sm="9">
                                                <Form.Control
                                                    type="datetime-local"
                                                    placeholder="Select Date"
                                                    value={formData.reminder_date}
                                                    onChange={(e) => handleFieldChange('reminder_date', e.target.value)}
                                                />
                                            </Col>
                                        </Form.Group>
                                    </div>

                                )}

                                <Form.Group as={Row} className="mb-0" controlId="formPlaintextUploadDocument">
                                    <Form.Label column >Upload Document</Form.Label>
                                    <Col sm="9">

                                        <Select
                                            isMulti
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            options={imageOptions}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            value={imageOptions.filter(opt => formData.doc_upload?.includes(opt.value))}
                                            onChange={(selectedOptions) => {
                                                const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                                handleFieldChange('doc_upload', values);
                                            }}
                                            placeholder="Select files"
                                            formatOptionLabel={formatOptionLabel}
                                        />
                                    </Col>

                                </Form.Group>

                                <p className="text-center mb-1">or</p>

                                <div className="dropfile " onDrop={handleDrop} onDragOver={handleDragOver}>
                                    <h3>Drag and drop files here</h3>
                                    <button className='btn btn-primary drpbtn' onClick={handleBrowseFiles}>Browse Files</button>
                                    <span>Maximum file size 4 MB</span>
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        style={{ display: 'none' }}
                                        onChange={handleFileChange}
                                        multiple
                                    />
                                </div>

                                {files?.map((file, index) => {
                                    const fileName = file.name;
                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                    const extension = fileName?.split(".").pop();
                                    return (
                                        <div key={index} className={`img-thumbnail ${selectedKeys.includes(index) ? 'primaryimg' : ''}`} onClick={() => handleImageSelect(index, file)}>
                                            {["jpeg", "jpg", "png", "webp"].includes(file.name.split(".")[file.name.split(".").length - 1]
                                            ) ? (
                                                <>
                                                    <img
                                                        src={URL.createObjectURL(file)}
                                                        alt="Preview"
                                                        style={{
                                                            maxWidth: "30px",
                                                            maxHeight: "30px",
                                                            marginRight: "5px",
                                                        }}

                                                    />
                                                    <span>
                                                        {/*file.file_name*/}
                                                        {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 40)}... .${extension}`}
                                                    </span>
                                                </>
                                            ) : (
                                                <>
                                                    <span className="d-flex align-items-center">
                                                        <img src={Docmnt} style={{
                                                            maxWidth: "30px",
                                                            maxHeight: "30px",
                                                            marginRight: "5px",
                                                        }} />
                                                        <span>{file.name}</span>
                                                    </span>
                                                </>
                                            )}


                                            <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                        </div>
                                    )
                                })}

                            </Col>
                            <Col md="12">
                                {/* <ActivityComments/> */}
                                <div className='edithtml' >

                                    <MessageBox
                                        value={formData.content || ''}
                                        onMessageChange={content => handleFieldChange('content', content)}
                                    />

                                </div>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-100 mx-auto are_bottom justify-content-center'>
                        <Button variant="primary" onClick={() => defineTask()}>
                            Save
                        </Button>
                        <Button variant="secondary" onClick={() => {
                            setActArcModal(false);
                            setFormData(initialFormData);
                        }}>
                            Discard
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>

            {/* </div> */}
        </>
    )
}

export default TaskManagement;